import { create } from 'zustand';

const OPEN_KEY = 'assistantOpen';
const remembered = () => {
  try {
    return localStorage.getItem(OPEN_KEY) === '1';
  } catch {
    return false;
  }
};
const remember = (open) => {
  try {
    localStorage.setItem(OPEN_KEY, open ? '1' : '0');
  } catch {
    // Private windows may refuse storage; the panel simply starts collapsed.
  }
};

/**
 * The assistant panel, docked on the right: whether it is open or collapsed
 * (remembered in this browser), whether the assistant is available to this
 * company, and a request to open it about something, such as a widget, with
 * a question ready.
 */
const useAssistant = create((set) => ({
  open: remembered(),
  status: null,
  request: null,
  setStatus: (status) => set({ status }),
  openPanel: (request = null) => {
    remember(true);
    set({ open: true, request });
  },
  closePanel: () => {
    remember(false);
    set({ open: false });
  },
  togglePanel: () => set((s) => {
    remember(!s.open);
    return { open: !s.open, request: null };
  }),
  takeRequest: () => {
    let taken = null;
    set((s) => {
      taken = s.request;
      return { request: null };
    });
    return taken;
  },
}));

export default useAssistant;
